import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    margin: theme.spacing(2),
    '& tr': {
      '& td:nth-child(2)': {
        textAlign: 'right',
      },
      '& td': {
        padding: theme.spacing(0.5),
      },
    },
    '& tbody': {
      '& tr:first-child td': {
        borderTop: '1px solid lightgrey',
      },
      '& tr:last-child td': {
        borderBottom: '1px solid lightgrey',
      },
      '& td:nth-child(2)': {
        fontWeight: 'bold',
      },
    },
    '& tfoot, & thead': {
      textAlign: 'center',
    },
  },
}))

const TooltipContent = ({
  chartLabel,
  month,
  records,
}: {
  chartLabel: string
  month: string
  records: { label: string; value: number; color: string }[]
}) => {
  const classes = useStyles()

  const total = records.reduce((acc, { value }) => acc + value, 0)

  return (
    <Typography variant="caption">
      <table className={classes.tooltip}>
        <thead>
          <tr>
            <th colSpan={3}>
              {total.toLocaleString()} Total {chartLabel}
            </th>
          </tr>
        </thead>
        <tbody>
          {records.map(({ label, value, color }) => (
            <tr key={label}>
              <td>
                {/* IconProp has messed up typing in current @fortawesome/fontawesome-svg-core, bumping versions may not be backwards compat  */}
                <FontAwesomeIcon
                  icon={faCircle as IconProp}
                  size="sm"
                  style={{ color }}
                />
              </td>
              <td>{value.toLocaleString()}</td>
              <td>{label}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={3}>
              Month of <strong>{month}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </Typography>
  )
}

export default TooltipContent
